import { Pipe, PipeTransform } from '@angular/core';
// Importación de Angular Fire 2
import { AngularFireDatabase } from 'angularfire2/database'
@Pipe({
  name: 'filtrarUnidades'
})
export class FiltrarUnidadesPipe implements PipeTransform {

    constructor(public af:AngularFireDatabase){}
    transform(arregloUnidades:any, filtro:any): any {
        // Arreglo de unidades que se van a mostrar
        let arregloNuevo:any = [];
        // Hace un loop por las unidades proporcionados para poder filtrarlos por id de operador
        if(filtro == undefined || filtro == ''){
            arregloNuevo= arregloUnidades
        }else{   
            arregloUnidades.forEach(unidad => {
                if(unidad.clave.toLowerCase().indexOf(filtro.toLowerCase()) > -1){
                    arregloNuevo.push(unidad)
                }else if(unidad.rotulo.toLowerCase().indexOf(filtro.toLowerCase()) > -1){
                    arregloNuevo.push(unidad)
                }
            });
        }
    return arregloNuevo;
    }
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/pipes/filtrar-unidades.pipe.ts